import { forwardRef, type Ref, type SVGProps } from 'react';
import { SvgIcon } from '../../components/icon/icon';

interface SVGRProps {
  title?: string;
  titleId?: string;
}
const HandHeart = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    aria-labelledby={titleId}
    {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m2.447 14.413 4.372-1.249a8 8 0 0 1 5.166.264l1.415.566a1.356 1.356 0 0 1-.832 2.574L9 15.675m-6.053 4.238 1.617-.539a3.53 3.53 0 0 1 2.688.191l2.139.894a3.61 3.61 0 0 0 3.054-.126l8.305-4.3a1.487 1.487 0 0 0-.026-2.654 1.5 1.5 0 0 0-1.062-.095l-4.012 1.147m.883-11.169a2.43 2.43 0 0 0-2.243 1.507 2.43 2.43 0 0 0-2.246-1.507 2.653 2.653 0 0 0-2.427 2.679c0 2.934 4.05 5.321 4.673 5.321s4.673-2.387 4.673-5.321a2.654 2.654 0 0 0-2.43-2.679"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
const ForwardRef = forwardRef(HandHeart) as SvgIcon;
export { ForwardRef as ReactComponent };
